import {Nav} from "react-bootstrap";
import {NavLink, Outlet} from "react-router";
import {useShop} from "../components/ShopContext";

// Inside SiteLayout, behind RequireAuth and RequireAdmin.
export function AdminLayout() {
    const {open: shopOpen} = useShop();
    return (
        <>
            <Nav variant="underline" className="mb-4">
                <Nav.Item><Nav.Link as={NavLink} to="/admin/customers">Customers</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/users">Users</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/products">Products</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/licenses">Licenses</Nav.Link></Nav.Item>
                {shopOpen && <Nav.Item><Nav.Link as={NavLink} to="/admin/orders">Orders</Nav.Link></Nav.Item>}
                <Nav.Item><Nav.Link as={NavLink} to="/admin/support">Support</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/documentation-downloads">Doc downloads</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/mailing-list">Mailing list</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/analytics">Analytics</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/audit-log">Audit log</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/settings">Settings</Nav.Link></Nav.Item>
            </Nav>
            <Outlet/>
        </>
    );
}
